<template>
  <div class="card card-default">
    <div class="card-body skew-shadow">
      <div class="row">
        <div class="col-md-9">
          <h1 class="fw-400 mb-3">{{ $t('main_pro_features') }}</h1>
          <h3 v-if="discountCoupon"><a :href="customUpgradeLink" class="p-1 animated-bg rounded">{{ discountCoupon }}</a> {{ $t('welcome_discount_code').replace(/7/, remainingDiscountDays) }}</h3>
        </div>
        <div class="col-md-3 text-right">
          <a :href="customUpgradeLink" class="btn btn-block btn-lg btn-light pos-relative" v-if="customUpgradeLink">
            {{ $t('upgrade_now') }} <span class="text-white bg-danger badge-discount rounded p-1">50% OFF</span>
          </a>
          <router-link to="/upgrade?from=features-banner" class="btn btn-block btn-lg btn-light" v-if="!customUpgradeLink">
            {{ $t('upgrade_now') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import User from '../services/user'

export default {
  name: 'UpgradeBanner',
  data: function () {
    return {
      user: {},
      remainingDiscountDays: 0,
      customUpgradeLink: '',
      discountCoupon: ''
    }
  },
  methods: {
    calculateRemainingDiscountDays: function () {
      const creationDate = new Date(this.user.createdAt)
      const expirationDate = new Date(creationDate)
      expirationDate.setDate(creationDate.getDate() + 6) // Añade 5 días desde la fecha de creación

      const today = new Date()
      const remainingTime = expirationDate - today // Diferencia en milisegundos

      // Calcula los días restantes (1 día = 24 horas * 60 minutos * 60 segundos * 1000 milisegundos)
      const remainingDiscountDays = Math.max(Math.ceil(remainingTime / (1000 * 60 * 60 * 24)), 0)
      return remainingDiscountDays
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = this.$user

    User.getUpgradeLink('annual').then(response => {
      if (response && response.data.coupon) {
        this.discountCoupon = response.data.coupon
        this.customUpgradeLink = response.data.url
        this.remainingDiscountDays = this.calculateRemainingDiscountDays()
      }
    })
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.badge-discount {
  position: absolute;
  top: -5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpgradeBanner.vue